var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import * as echarts from "echarts";
import { buildLegend, buildTooltip, buildVisualMap, mergeGeoHeatmapSettings, } from "./shared";
var DEFAULT_GEO_MAP_NAME = "simple-geo";
// 简单的默认地图数据（如果项目中没有提供地图文件）
var DEFAULT_SIMPLE_GEO_JSON = {
    type: "FeatureCollection",
    features: [],
};
// 尝试动态导入地图文件，如果不存在则使用默认值
var simpleGeoJson = DEFAULT_SIMPLE_GEO_JSON;
// 注意：地图文件是可选的，如果项目中没有提供，使用默认空地图
// 这样可以避免构建时找不到文件的错误
var MAP_RESOURCES = (_a = {},
    _a[DEFAULT_GEO_MAP_NAME] = simpleGeoJson,
    _a);
function ensureMapRegistered(mapName) {
    var targetName = mapName && MAP_RESOURCES[mapName] ? mapName : DEFAULT_GEO_MAP_NAME;
    if (!echarts.getMap(targetName)) {
        var resource = MAP_RESOURCES[targetName];
        if (resource) {
            echarts.registerMap(targetName, resource);
        }
    }
    return targetName;
}
function getGeoValueStats(points) {
    var min;
    var max;
    points.forEach(function (point) {
        if (min === undefined || point.value < min) {
            min = point.value;
        }
        if (max === undefined || point.value > max) {
            max = point.value;
        }
    });
    return { min: min, max: max };
}
var geoHeatmapAdapter = {
    type: "geoHeatmap",
    buildOption: function (ctx) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        var data = ctx.data;
        var mergedSettings = mergeGeoHeatmapSettings(ctx.settings);
        var requestedMapName = (_b = (_a = mergedSettings.geo) === null || _a === void 0 ? void 0 : _a.map) !== null && _b !== void 0 ? _b : (_c = data.geo) === null || _c === void 0 ? void 0 : _c.map;
        var mapName = ensureMapRegistered(requestedMapName);
        var geoConfig = {
            map: mapName,
            roam: ((_g = (_e = (_d = mergedSettings.geo) === null || _d === void 0 ? void 0 : _d.roam) !== null && _e !== void 0 ? _e : (_f = data.geo) === null || _f === void 0 ? void 0 : _f.roam) !== null && _g !== void 0 ? _g : MAP_RESOURCES[mapName]) ? true : true,
            zoom: (_l = (_j = (_h = mergedSettings.geo) === null || _h === void 0 ? void 0 : _h.zoom) !== null && _j !== void 0 ? _j : (_k = data.geo) === null || _k === void 0 ? void 0 : _k.zoom) !== null && _l !== void 0 ? _l : 1,
        };
        var _t = getGeoValueStats(data.points), min = _t.min, max = _t.max;
        var legend = buildLegend(data.legend, mergedSettings.legend);
        var tooltip = buildTooltip(data.tooltip, {
            trigger: (_o = (_m = mergedSettings.tooltip) === null || _m === void 0 ? void 0 : _m.trigger) !== null && _o !== void 0 ? _o : "item",
            enable: (_p = mergedSettings.tooltip) === null || _p === void 0 ? void 0 : _p.enable,
            formatter: (_q = mergedSettings.tooltip) === null || _q === void 0 ? void 0 : _q.formatter,
        });
        var visualMap = buildVisualMap(data.visualMap, mergedSettings.visualMap, { min: min, max: max });
        var series = [
            {
                type: "heatmap",
                coordinateSystem: "geo",
                data: data.points.map(function (point) { return ({
                    value: [point.lng, point.lat, point.value],
                    name: point.name,
                }); }),
                pointSize: 5,
                blurSize: 6,
            },
        ];
        var option = {
            geo: {
                map: mapName,
                roam: (_r = geoConfig.roam) !== null && _r !== void 0 ? _r : true,
                zoom: (_s = geoConfig.zoom) !== null && _s !== void 0 ? _s : 1,
                silent: false,
                label: { show: false },
                itemStyle: {
                    borderColor: "#fff",
                    areaColor: "#f2f2f2",
                },
                emphasis: {
                    label: { show: false },
                    itemStyle: {
                        areaColor: "#d3dffd",
                    },
                },
            },
            legend: legend,
            tooltip: tooltip,
            series: series,
        };
        if (visualMap) {
            option.visualMap = __assign({ type: "continuous", orient: "vertical", left: "left", bottom: 20 }, visualMap);
        }
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: false },
        tooltip: { enable: true, trigger: "item" },
        visualMap: { show: true, calculable: true },
        geo: { map: DEFAULT_GEO_MAP_NAME, roam: true, zoom: 1 },
    }); },
};
export default geoHeatmapAdapter;
